$(()=>{ new Clipboard('.icon-button-copy'); });
